import { getState, setState } from "./state/store";
import { nid } from "./utils/id";

export function ensureInitialClass() {
    const s = getState();

    if (!s.classes.length) {
        const id = nid("cls_");
        setState(ns => {
            ns.classes.push({
                id, name: "Period 1",
                students: [],
                constraints: { mustTogether: [], mustApart: [] },
                settings: {
                    targetSize: 4, minSize: 3, maxSize: 5,
                    balanceSkill: true, tagBehavior: new Map(),
                    tags: [], mode: 'groups'
                },
                lastGroups: []
            });
            ns.activeClassId = id;
        });
    } else if (!s.activeClassId && s.classes.length > 0) {
        setState(ns => {
            const firstClass = ns.classes[0];
            if (firstClass) {
                ns.activeClassId = firstClass.id;
            }
        });
    }
}
